import { Visibility } from '@fullstory/proto/fs/gcloud/dstore/protoauditstore';
import {
  GetBehaviorSignalSettingsResponse,
  GetDetectionsConfigurationRulesResponse,
  GetRecordingFeaturesResponse,
} from '@fullstory/proto/fs/services/ingestion-settings';
import { timestamp, int64 } from '@fullstory/proto/google/protobuf';

export const GET_BEHAVIOR_SIGNAL_SETTINGS_RESPONSE: GetBehaviorSignalSettingsResponse = {
  versions: [],
};

export const GET_DETECTIONS_CONFIGURATION_RULES_RESPONSE: GetDetectionsConfigurationRulesResponse =
  {
    detectionsConfigRules: { detectionsEnabled: true },
  };

export const GET_RECORDING_FEATURES_RESPONSE: GetRecordingFeaturesResponse = {
  versions: [
    {
      enabled: true,
      consoleWatcher: true,
      ajaxWatcher: true,
      resourceUploading: false,
      recordingShutoff: false,
      metadata: {
        lastUpdated: '2022-05-20T13:35:54.809533Z' as timestamp,
        lastUpdatedBy: 'email@domain.com',
        created: '2020-09-08T15:57:20.830Z' as timestamp,
        createdBy: 'email@domain.com',
        archived: false,
        visibility: Visibility.UNSET,
        version: int64.fromNumber(1653053754809),
        sequentialVersion: int64.fromNumber(6),
      },
      trafficFiltering: 0,
      clientSideRageClick: false,
      recordingActive: 0,
      mobileImageUnmaskMode: 0,
      keepRecordingType: 0,
      customEndpoint: '',
      dropRate: 0,
      canvasWatcherMode: 0,
    },
  ],
};
